import { Injectable, inject } from '@angular/core';
import { AlertaComponent } from './alerta.component';
import { MatDialog } from '@angular/material/dialog';
import { title } from 'process';

@Injectable({
  providedIn: 'root'
})
export class AlertaService {
  private dialog = inject(MatDialog);
  private dialogHTML = 'basic';
  private optionsDialog = {
    width: 'auto',
    data: { html: 'basic',  title: 'titulo', description: 'description', aceptar: 'ACEPTAR', cancelar: 'CANCELAR' },
    enterAnimationDuration: '100ms',
    exitAnimationDuration: '100ms'
  };
  
  open(titulo:string, descripcion: string): void {
    this.optionsDialog.data.html = 'basic',
    this.optionsDialog.data = {...this.optionsDialog.data, ...{title: titulo, description: descripcion}};
    this.dialog.open(AlertaComponent, this.optionsDialog);
  }

  openData(data:any) {
    this.optionsDialog.data = {...this.optionsDialog.data, ...data};
    const dialogRef = this.dialog.open(AlertaComponent, this.optionsDialog);
    return dialogRef;
  }

  confirm(data:any) {
    data.html = 'advance';
    this.optionsDialog.data = {...this.optionsDialog.data, ...data};
    const dialogRef = this.dialog.open(AlertaComponent, this.optionsDialog);
    return dialogRef;
  }

  confirmHTML(data:any) {
    data.html = 'confirm_html';
    this.optionsDialog.data = {...this.optionsDialog.data, ...data};
    const dialogRef = this.dialog.open(AlertaComponent, this.optionsDialog);
    return dialogRef;
  }

  motivoCancelacion(data:any) {
    data.html = 'motivo_cancelacion';
    data.title = '¿Estás seguro de cancelar este entregable?';
    data.description = 'Ingresa el motivo de cancelación, no olvides que esta acción es permanente.';
    this.optionsDialog.data = {...this.optionsDialog.data, ...data};
    const dialogRef = this.dialog.open(AlertaComponent, this.optionsDialog);
    return dialogRef;
  }

  eliminarComentario(data:any) {
    data.html = 'eliminar_comentario';
    data.title = '¿Está seguro de eliminar el comentario?';
    data.description = 'Confirme que desea eliminar el comentario:';
    this.optionsDialog.data = {...this.optionsDialog.data, ...data};
    const dialogRef = this.dialog.open(AlertaComponent, this.optionsDialog);
    return dialogRef;
  }

  treeMap() {
    this.optionsDialog.data = {...this.optionsDialog.data, ...{ html: 'tree_map' }};
    const dialogRef = this.dialog.open(AlertaComponent, this.optionsDialog);
    return dialogRef;
  }

  closeAll() {
    this.dialog.closeAll();
  }
}

/*private alertaService = inject(AlertaService);
this.alertaService.open('titulo', 'descripcion');
const dialogRef = this.alertaService.openData({title:'titulo', description:'descripcion'});
dialogRef.afterClosed().subscribe((result:any) => {
  console.log(result);
});*/